/**
 * Voice settings single-source-of-truth helpers (UI-owned fields only).
 * No customer-specific literals. Stability numeric direction is never inverted.
 */

export const VOICE_STABILITY_LABEL_LEFT = "Variable";
export const VOICE_STABILITY_LABEL_RIGHT = "Consistent";

export type VoiceSettingsServerPayload = {
  voice_id?: unknown;
  stability?: unknown;
  similarity_boost?: unknown;
  clarity?: unknown;
  updated_at?: unknown;
};

export type HydratedVoiceSettings = {
  voiceId: string;
  stability: number;
  similarity: number;
  updatedAt: string | null;
};

/** Save is allowed only after a successful GET hydrated real server values. */
export function canSaveVoiceSettings(opts: {
  voiceSettingsLoaded: boolean;
  stability: number | null;
  similarity: number | null;
}): boolean {
  return (
    opts.voiceSettingsLoaded === true &&
    typeof opts.stability === "number" &&
    Number.isFinite(opts.stability) &&
    typeof opts.similarity === "number" &&
    Number.isFinite(opts.similarity)
  );
}

export function parseVoiceSettingsFromServer(
  settings: VoiceSettingsServerPayload | null | undefined
): HydratedVoiceSettings | null {
  if (!settings || typeof settings !== "object") return null;
  const stability = settings.stability;
  const simRaw =
    typeof settings.similarity_boost === "number" &&
    !Number.isNaN(settings.similarity_boost)
      ? settings.similarity_boost
      : typeof settings.clarity === "number" && !Number.isNaN(settings.clarity)
        ? settings.clarity
        : undefined;
  if (typeof stability !== "number" || Number.isNaN(stability)) return null;
  if (typeof simRaw !== "number" || Number.isNaN(simRaw)) return null;
  const voiceId =
    typeof settings.voice_id === "string" ? settings.voice_id.trim() : "";
  const updatedAt =
    typeof settings.updated_at === "string" && settings.updated_at.trim()
      ? settings.updated_at.trim()
      : null;
  return {
    voiceId,
    stability,
    similarity: simRaw,
    updatedAt,
  };
}
